import React, {useEffect, useRef, useState} from "react";
import {APIGetReport} from "../../schoolReport/api/schoolReports";
import {useNavigate, useParams} from "react-router-dom";
import {useAuth} from "../../../../hooks/useAuth";
import {useReactToPrint} from "react-to-print";
import Loading from "../../../../shared/ui/Loading";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import ClassroomStandardsReport from "../components/ClassroomStandardsReport";

const ClassroomReport = () => {
    const {id = ""} = useParams();
    const {update} = useAuth();
    const reportPrintRef = useRef(null);
    const navigate = useNavigate();
    const [loading, setLoading] = useState<boolean>(true);
    const [reportData, setReportData] = useState<any>();
    const [isStandardsReport, setIsStandardsReport] = useState<boolean>(false);

    useEffect(() => {
        if (id !== "") {
            setLoading(true);
            APIGetReport({id: id})
                .then((response) => {
                    if (response.data.success) {
                        let data = response.data.data.item;
                        setReportData(data);
                        setIsStandardsReport(data.payload.has_standard);
                    } else {
                        update("error", {show: true, code: "A002"});
                    }
                })
                .catch(() => {
                    // console.log("getReport ERR", err);
                    update("error", {show: true, code: "A001"});
                })
                .finally(() => {
                    setLoading(false);
                })
        } else {
            navigate("/rapoarte-scoala");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    const handlePrint = useReactToPrint({
        content: () => reportPrintRef.current,
    });

    if(loading) {
        return (
            <Box mt={3} display="flex" alignItems="center" width="100%">
                <Loading show={true}/>
            </Box>
        )
    }

    return (
        <>
            <div ref={reportPrintRef} className="print">
                {<ClassroomStandardsReport report={reportData} isPrinting={true} isStandard={isStandardsReport}/>}
            </div>
            <div>
                {<ClassroomStandardsReport report={reportData} isPrinting={false} isStandard={isStandardsReport}/>}
            </div>
            {reportData.payload.finished_tests_count !== 0 && (
                <div className="print-bar screen no-print">
                    <Button type="submit" variant="contained" onClick={handlePrint}
                            style={{marginRight: 20}}>
                        Tipărește
                    </Button>
                </div>
            )}
        </>
    );
}

export default ClassroomReport;